<template>
  <div class="hamburgerButton" @click="clicked" :class="{open: isClicked}">
    <div>
      <span></span>
      <span></span>
      <span></span>
  </div>
  </div>
</template>

<script>
export default {
  name: 'hamburgerButton',
  data(){
    return{
      isClicked: this.clickStatus
    }
  },
  props:{
    clickStatus: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    clickStatus(newVal) {
      this.isClicked = newVal
    }
  },
  methods: {
    clicked(){
      this.isClicked = !this.isClicked
      this.$emit('clicked', this.isClicked)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.hamburgerButton{
  $drawerWidth: 70%;   // ドロワー幅
  $triggerSize: 18px;  // トリガーサイズ（バーガー幅）
  $baseSpeed: 300ms;   // ベース速度(ドロワー開く速度)
  $triggerXDist: 36px; // トリガーX位置
  
  color: $col_white; 
  width: $triggerSize;
  height: $triggerSize;
  position: absolute;
  left: 0;
  top: 13px;
  pointer-events: auto;
  transition: all $baseSpeed ease 0s;
  cursor: pointer;
  div {
    width: 100%;
    height: 100%;
    position: relative;
    span {
      width: $triggerSize;
      height: 2px;
      background: $col_white;
      position: absolute;
      border-radius: 1.5px;
      top: $triggerSize/2;
      left: 0;
      transition: all $baseSpeed * 1.5 cubic-bezier(.88,.38,.32,1.06) 0s;
      &:nth-child(1) {
        transform: translate(0,-$triggerSize*0.8/2);
      }
      &:nth-child(3) {
        transform: translate(0,$triggerSize*0.8/2);
      }
    }
  }
    &.open {
        div {
          span {
            background: $col_white;
            &:nth-child(1) {
              transform: rotate(-45deg) translate(0,0) scale(1.2570, 1);
            }
            &:nth-child(2) {
              opacity: 0;
            }
            &:nth-child(3) {
              transform: rotate(45deg) translate(0,0) scale(1.2570, 1);
            }
          }
        
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/HumburgerButton.vue